import React from "react";
import {Button, Paper, ClickAwayListener, TextField} from "@material-ui/core";
import "./supplierInvoices/EditInvoices.css"
import Autocomplete from "@material-ui/lab/Autocomplete";
import {KeyboardDatePicker, MuiPickersUtilsProvider} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import PropTypes from "prop-types";
import withShipment from "../../withShipment";
import {saveCarrierInvoicePaymentDetails, saveSupplierInvoicePaymentDetails} from "../../redux/actions/invoices";
import {
    INVOICE_TYPE_CARRIER,
    INVOICE_TYPE_CUSTOMER_INVOICE,
    INVOICE_TYPE_FTL_CARRIER,
    INVOICE_TYPE_SUPPLIER
} from "./constants";
import {LTL_FTL_CARRIER, STANDARD_CARRIER} from "./carrierInvoices/constants";
import format from 'date-fns/format';
import {saveCustomerInvoicePaymentDetails} from "../../redux/actions/customer";
import moment from "moment";

class PaymentPopper extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            paymentDate: new Date(),
            bankAccount: null,
            referenceId: "",
        }
    }

    handleChange = (e) => {
        this.setState({ [e.target.name]: e.target.value})
    }

    handleClose = () => {
        this.props.handleClosePopper()
    }

    formatDate = (date) => {
        try {
            return format(date, 'yyyy-MM-dd');
        }
        catch (e) {
            return date
        }
    }

    handleSave = () => {
        const data = {
            InvoiceIds: this.props.selectedInvoiceIds,
            paymentDate: this.formatDate(this.state.paymentDate),
            bankAccount: this.state.bankAccount,
            referenceId: this.state.referenceId,
        }
        switch (this.props.invoiceType) {
            case INVOICE_TYPE_SUPPLIER:
                this.props.saveSupplierInvoicePaymentDetails(data);
                return
            case INVOICE_TYPE_CARRIER:
                this.props.saveCarrierInvoicePaymentDetails(data, STANDARD_CARRIER);
                return
            case INVOICE_TYPE_FTL_CARRIER:
                this.props.saveCarrierInvoicePaymentDetails(data,LTL_FTL_CARRIER);
                return
            case INVOICE_TYPE_CUSTOMER_INVOICE:
                this.props.saveCustomerInvoicePaymentDetails(data);
                return;
            default:
        }
        this.props.handleClosePopper()
    }

    render() {
        return (
            <>
                <ClickAwayListener onClickAway={this.handleClose}>
                    <Paper className="supplier-payment-popper-container">
                        <div className="supplier-payment-popper-item">
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                <KeyboardDatePicker
                                    name="paymentDate"
                                    label="Payment Date"
                                    value={this.state.paymentDate}
                                    onChange={(date) => this.handleChange({ target: { name: "paymentDate", value: date } })}
                                    format="yyyy-MM-dd"
                                    style={{ width: "250px" }}
                                    variant="inline"
                                    inputVariant="outlined"
                                    InputLabelProps={{ shrink: true }}
                                    InputAdornmentProps={{ position: "start" }}
                                    autoOk
                                />
                            </MuiPickersUtilsProvider>
                        </div>
                        {this.props.invoiceType !== INVOICE_TYPE_CUSTOMER_INVOICE && <div className="supplier-payment-popper-item">
                            <Autocomplete
                                options={this.props.bankAccounts}
                                getOptionLabel={(option) => `${option.name} (${option.accountNumber})`}
                                value={this.state.bankAccount}
                                onChange={(e, value) => this.handleChange({target: {name: "bankAccount", value}})}
                                renderInput={(params) =>
                                    <TextField
                                        {...params}
                                        name="bankAccount"
                                        label="Bank Account"
                                        variant="outlined"
                                        InputLabelProps={{shrink: true}}
                                    />
                                }
                                style={{width: "250px"}}
                            />
                        </div>}

                        <div className="supplier-payment-popper-item">
                            <TextField
                                variant="outlined"
                                name="referenceId"
                                label="Reference Id"
                                value={this.state.referenceId}
                                onChange={(e) => this.handleChange(e)}
                                InputLabelProps={{shrink: true}}
                                style={{width: "250px"}}
                            />
                        </div>
                        <div className="supplier-payment-popper-buttons">
                            <Button variant='contained' onClick={this.handleClose}
                                    style={{width: '100px'}}>Close</Button>
                            <Button variant='contained' onClick={this.handleSave} color="primary"
                                    style={{width: '100px'}}>Save</Button>
                        </div>
                    </Paper>
                </ClickAwayListener>
            </>
        )
    }
}

const actionCreators = {
    saveSupplierInvoicePaymentDetails,
    saveCarrierInvoicePaymentDetails,
    saveCustomerInvoicePaymentDetails
}

PaymentPopper.propTypes = {
    bankAccounts: PropTypes.array,
    selectedSupplierIds: PropTypes.array,
}

PaymentPopper.defaultProps = {
    bankAccounts: [],
    selectedSupplierIds: []
}

export default withShipment({
    actionCreators
}, PaymentPopper);